<div class="image-uploader" :class="{ 'image-uploader--without-title': !showUploadLabel }">
  <div
    v-if="canUpload"
    ref="pasteZone"
    class="image-upload-paste-zone"
    :class="{ 'is-paste-focused': pasteFocused }"
    tabindex="0"
    role="region"
    aria-label="Image upload area. Click then paste an image, or use Upload."
    @click="onPasteZoneClick"
    @focus="pasteFocused = true"
    @blur="pasteFocused = false"
    @paste="onPaste"
  >
    <div v-if="hasImages" class="ui four column grid image-upload-grid">
      <div
        v-for="(image, index) in item.images"
        :key="imageKey(image, index)"
        class="column image-upload-column"
        :class="{
          'is-dragging': dragIndex === index,
          'is-drag-over': dragOverIndex === index && dragIndex !== index
        }"
        draggable="true"
        @dragstart="onDragStart(index, $event)"
        @dragenter.prevent="onDragEnter(index)"
        @dragover.prevent="onDragOver($event)"
        @drop.prevent="onDrop(index)"
        @dragend="onDragEnd"
      >
        <div class="ui image image-upload-preview">
          <button
            type="button"
            class="image-delete-btn"
            draggable="false"
            aria-label="Remove image"
            @click.prevent.stop="remove(image)"
            @mousedown.stop.prevent
          >
            <img src="../../../assets/img/icn_trash.svg" alt="" aria-hidden="true" draggable="false">
          </button>
          <img :src="getUrl(image)" draggable="false" alt="" @error="onImageError">
        </div>
      </div>
    </div>
    <div v-else class="ui four column grid">
      <div class="column">
        <div class="ui image image-upload-preview image-upload-preview--placeholder">
          <img :src="placeholderSrc" alt="No image available" draggable="false">
        </div>
      </div>
    </div>
  </div>

  <div v-else>
    <div v-if="hasImages" class="ui four column grid image-upload-grid">
      <div
        v-for="(image, index) in item.images"
        :key="imageKey(image, index)"
        class="column image-upload-column"
      >
        <div class="ui image image-upload-preview">
          <img :src="getUrl(image)" draggable="false" alt="" @error="onImageError">
        </div>
      </div>
    </div>
    <div v-else class="ui four column grid">
      <div class="column">
        <div class="ui image image-upload-preview image-upload-preview--placeholder">
          <img :src="placeholderSrc" alt="No image available" draggable="false">
        </div>
      </div>
    </div>
  </div>

  <br>

  <div v-if="canUpload" class="fields">
    <div class="sixteen wide field">
      <label v-if="showUploadLabel" class="small image-upload-title">Upload Images</label>
      <p class="small image-upload-guidance">Recommended 300px x 300px. Saved in .png or jpg format.</p>
      <label :id="uploadLabelId" :for="uploadInputId" class="ui basic button smardie-btn-secondary">Upload</label>
      <input
        type="file"
        name="images[]"
        :id="uploadInputId"
        multiple
        accept="image/*"
        @change="changed($event)"
      >
    </div>
  </div>
</div>
